import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import Drip from 'drip';
import { isProd, ajaxPreUrl } from '@/config/';
import { matchFeatureUrl } from '@/apis';
import { mtguardInit } from '../../utils/mtguard';
// 美团安全基线ab test
export function getMtGuardABtest() {
  return _getMtGuardABtest.apply(this, arguments);
}
function _getMtGuardABtest() {
  _getMtGuardABtest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var abtestResult, uuid, params;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (isProd) {
            _context2.next = 3;
            break;
          }
          mtguardInit();
          return _context2.abrupt("return");
        case 3:
          _context2.next = 5;
          return Drip.getStore('_mtguard_abtest_');
        case 5:
          abtestResult = _context2.sent;
          if (!(abtestResult !== undefined)) {
            _context2.next = 9;
            break;
          }
          if (abtestResult) {
            mtguardInit();
          }
          return _context2.abrupt("return");
        case 9:
          _context2.next = 11;
          return Drip.getUuid();
        case 11:
          uuid = _context2.sent;
          params = isProd ? {
            olapeId: 60,
            layerId: 190,
            filterId: uuid
          } : {
            olapeId: 536,
            layerId: 121,
            filterId: uuid
          };
          axios.get("".concat(ajaxPreUrl, "/getMatchedFeature"), {
            params: params
          }).then(function (_ref2) {
            var code = _ref2.code,
              data = _ref2.data;
            // 实验命中
            if (code === 200 && data) {
              mtguardInit();
            }
            Drip.setStore('_mtguard_abtest_', !!(code === 200 && data), {
              expires: '5M'
            });
          }).catch(function () {
            return {};
          });
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getMtGuardABtest.apply(this, arguments);
}
var getABIdData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _Drip$constant$uaInfo, IS_MEITUAN, IS_MAOYAN, IS_DIANPING, myUUid, filterId, olapeId, layerId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _Drip$constant$uaInfo = Drip.constant.uaInfo, IS_MEITUAN = _Drip$constant$uaInfo.IS_MEITUAN, IS_MAOYAN = _Drip$constant$uaInfo.IS_MAOYAN, IS_DIANPING = _Drip$constant$uaInfo.IS_DIANPING;
          _context.next = 3;
          return Drip.getUuid();
        case 3:
          myUUid = _context.sent;
          filterId = myUUid;
          olapeId = 593;
          layerId = 0;
          if (IS_MEITUAN || IS_DIANPING) {
            layerId = 179;
          }
          if (IS_MAOYAN) {
            layerId = 177;
          }
          if (isProd) {
            olapeId = 72;
            if (IS_MEITUAN || IS_DIANPING) {
              layerId = 219;
            }
            if (IS_MAOYAN) {
              layerId = 218;
            }
          }
          return _context.abrupt("return", {
            olapeId: olapeId,
            layerId: layerId,
            filterId: filterId
          });
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getABIdData() {
    return _ref.apply(this, arguments);
  };
}();
export function getIsAbTest() {
  return _getIsAbTest.apply(this, arguments);
}
function _getIsAbTest() {
  _getIsAbTest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _getABIdData,
      _Drip$constant$uaInfo2,
      IS_MEITUAN,
      IS_MAOYAN,
      IS_DIANPING,
      needRunABTest,
      _yield$_getABIdData,
      olapeId,
      layerId,
      filterId,
      _yield$axios$get,
      code,
      data,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _getABIdData = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : getABIdData;
          _Drip$constant$uaInfo2 = Drip.constant.uaInfo, IS_MEITUAN = _Drip$constant$uaInfo2.IS_MEITUAN, IS_MAOYAN = _Drip$constant$uaInfo2.IS_MAOYAN, IS_DIANPING = _Drip$constant$uaInfo2.IS_DIANPING;
          needRunABTest = IS_MEITUAN || IS_MAOYAN || IS_DIANPING;
          if (needRunABTest) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return", false);
        case 5:
          _context3.next = 7;
          return _getABIdData();
        case 7:
          _yield$_getABIdData = _context3.sent;
          olapeId = _yield$_getABIdData.olapeId;
          layerId = _yield$_getABIdData.layerId;
          filterId = _yield$_getABIdData.filterId;
          _context3.prev = 11;
          _context3.next = 14;
          return axios.get("".concat(matchFeatureUrl, "?olapeId=").concat(olapeId, "&layerId=").concat(layerId, "&filterId=").concat(filterId), {
            timeout: 3000
          });
        case 14:
          _yield$axios$get = _context3.sent;
          code = _yield$axios$get.code;
          data = _yield$axios$get.data;
          if (!(code === 200)) {
            _context3.next = 19;
            break;
          }
          return _context3.abrupt("return", data);
        case 19:
          return _context3.abrupt("return", false);
        case 22:
          _context3.prev = 22;
          _context3.t0 = _context3["catch"](11);
          return _context3.abrupt("return", false);
        case 25:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[11, 22]]);
  }));
  return _getIsAbTest.apply(this, arguments);
}